import { InjectionToken } from '@angular/core';

export const FORMS_SECURE_UPLOAD_URL = new InjectionToken<string>('FORMS_SECURE_UPLOAD_URL');
